// =============================================================
// SKIP LINK — WCAG 2.4.1 bypass blocks
// =============================================================

interface SkipLinkProps {
  target?: string;
  label?: string;
}

export function SkipLink({ target = "#main", label = "İçeriğe geç" }: SkipLinkProps) {
  return (
    <a href={target} className="skip-link">
      {label}
    </a>
  );
}